<template>
    <div>
        <b-button
            variant="primary"
            @click.stop="abrirModal()"
            :disabled="operacao != 'D' || rateios.length < 1">
            <span><i class="fa fa-check-circle-o mr-2"></i> Comprometer </span>
        </b-button>
        <b-modal
            id="modalComprometer"
            v-model="mostrarModal"
            @show="preencherForm()">
            <div slot="modal-title">
                Comprometer
            </div>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.dataMovimento.$error ? false : null"
                        invalid-feedback="Data do movimento é obrigatória">
                        <label>Data do movimento</label>
                        <date-picker
                            v-model="dataMovimento"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dataMovimento.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Histórico</label>
                        <b-form-textarea
                            v-model="historico"
                            :rows="4"
                            @input="$v.historico.$touch()"
                            :state="$v.historico.$error ? false : null"
                            :disabled="!$temAcessoView('CONT-COMPR-04')"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>
                            O histórico do movimento é obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    <i class="fa fa-times-circle-o mr-2"></i>
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarComprometer()"
                    class="ml-1">
                    <i class="fa fa-check-circle-o mr-2"></i>
                    Comprometer
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ConveniosServicos from '../../ConveniosServicos'

export default {
    components: {},

    props: {
        convenio: {
            type: Object,
            default: () => ({})
        },

        comprometimento: {
            type: Object,
            default: () => ({})
        },

        operacao: {
            type: String
        },

        rateios: {
            type: Array,
        }
    },

    data() {
        return {
            mostrarModal: false,
            dataMovimento: null,
            historico: null
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        preencherForm() {
            this.dataMovimento = this.$moment(this.comprometimento.dtMovimento).format('DD/MM/YYYY')
            this.historico = this.comprometimento.vcHistorico
        },

        confirmarComprometer() {
            this.$swal({
                title: 'Comprometimento',
                html: `Confirma a realização do comprometimento de id ${this.comprometimento.chaveOrigem} do 
                convênio ${this.convenio.vcCodigoEstruturado} no RM?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.comprometer()
                }
            })
        },

        comprometer() {
            this.$store.dispatch('addRequest')
            let comprometimentoDto = {
                idConvenio: this.convenio.idConvenio,
                idComprometimentoRequisicao: this.comprometimento.idComprometimentoRequisicao,
                dataMovimento: this.$moment(this.dataMovimento, 'DD/MM/YYYY'),
                historico: this.historico
            }
            ConveniosServicos.comprometer(comprometimentoDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Comprometido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarCronograma')
                        } else {
                            this.$emit('atualizarErros', response.errors)
                        }
                    }
                    this.fecharModal()
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    validations: {
        dataMovimento: {
            required
        },
        historico: {
            required
        }
    }
}
</script>
